export const currentRouteSelector = state => state.router.location.pathname;
export const previousRouteSelector = state => state.app.location.previousLocation;
